/* Shared popup fade. Keep native dialogs in the top layer until exit finishes,
   including Safari where CSS overlay transitions are not available. */
(function () {
  'use strict';
  if (window.fizzyPopupMotion) return;
  var pending = new WeakMap();
  var bound = new WeakSet();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cancel(element) {
    var cleanup = pending.get(element);
    if (cleanup) cleanup();
    pending.delete(element);
  }
  function reveal(element, show) {
    if (!element) return;
    var phase = element.getAttribute('data-fizzy-popup-motion');
    if (phase === 'open' || phase === 'opening') return;
    cancel(element);
    element.setAttribute('data-fizzy-popup-motion', 'opening');
    show();
    if (reduced.matches) {
      element.setAttribute('data-fizzy-popup-motion', 'open');
      return;
    }
    // Give newly displayed surfaces a painted transparent frame. A synchronous
    // class swap can otherwise skip entry transitions on hidden/modal elements.
    void getComputedStyle(element).opacity;
    var frame = window.requestAnimationFrame(function () {
      frame = window.requestAnimationFrame(function () {
        pending.delete(element);
        element.setAttribute('data-fizzy-popup-motion', 'open');
      });
    });
    pending.set(element, function () { window.cancelAnimationFrame(frame); });
  }
  function dismiss(element, hide) {
    if (!element) return;
    var phase = element.getAttribute('data-fizzy-popup-motion');
    if (phase === 'closing' || phase === 'closed') return;
    cancel(element);
    if (reduced.matches || !element.isConnected) {
      element.setAttribute('data-fizzy-popup-motion', 'closed');
      hide();
      return;
    }
    var timer;
    function cleanup() {
      window.clearTimeout(timer);
      element.removeEventListener('transitionend', ended);
    }
    function finish() {
      cleanup();
      pending.delete(element);
      element.setAttribute('data-fizzy-popup-motion', 'closed');
      hide();
    }
    function ended(event) {
      if (event.target === element && event.propertyName === 'opacity') finish();
    }
    element.addEventListener('transitionend', ended);
    pending.set(element, cleanup);
    element.setAttribute('data-fizzy-popup-motion', 'closing');
    var seconds = parseFloat(getComputedStyle(element).transitionDuration) || 0;
    timer = window.setTimeout(finish, seconds * 1000 + 50);
  }
  function open(dialog) {
    if (!dialog) return;
    if (!bound.has(dialog)) {
      bound.add(dialog);
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        close(dialog);
      });
      dialog.addEventListener('close', function () {
        if (dialog.open) return; // Ignore a queued close event after a reopen.
        cancel(dialog);
        dialog.setAttribute('data-fizzy-popup-motion', 'closed');
      });
    }
    reveal(dialog, function () { if (!dialog.open) dialog.showModal(); });
  }
  function close(dialog) {
    if (!dialog || !dialog.open) return;
    dismiss(dialog, function () { if (dialog.open) dialog.close(); });
  }
  window.fizzyPopupMotion = { open: open, close: close, reveal: reveal, dismiss: dismiss };
})();
